import React, { Component } from "react";
import {
  Router,
  RouterProps,
  Styled
} from "../../../toolkit/decorators/Artifact";
import { InvitadosDetalleDispatcher } from "../../containers/invitadosDetalle/InvitadosDetalle.dispatcher";
import { InvitadosDetalleStore } from "../../containers/invitadosDetalle/InvitadosDetalle.store";
import s from "./styles.scss";
import { Container, Row, UncontrolledTooltip } from "reactstrap";
import { errorNotification } from "../../../utils/notifications";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faInfoCircle,
  faShoppingCart,
  faSpinner,
  faUser
} from "@fortawesome/free-solid-svg-icons";
import permissionCodes from "../../../utils/permissionCodes";
import { userHasPermission } from "../../../utils/accessTree";
import { BFF_URL, IMAGES_ENDPOINT } from "../../../utils/constants";
import InvitadosDetalleTab from "./InvitadosDetalle.tabs";
import InvitadosDetalleInfo from "./InvitadosDetalle.info";

const { MENU_CARRITO } = permissionCodes;

interface Props
  extends InvitadosDetalleDispatcher,
    InvitadosDetalleStore,
    RouterProps<any> {}

interface State {}

@Router()
@Styled(s)
export default class InvitadosDetalleComponent extends Component<Props, State> {
  state = {
    activeTab: null
  };

  async componentDidMount(): Promise<void> {
    this.props.clearInvitado();
    const { id: idInvitado } = this.props.match.params;
    const preview = await this.props.getInvitado(idInvitado);

    if (!preview.fulfilled) {
      errorNotification("Error al cargar los datos del invitado");
    }
  }

  render() {
    if (!this.props.invitado) {
      return (
        <Container>
          <FontAwesomeIcon icon={faSpinner} pulse />
        </Container>
      );
    }

    const invitado = this.props.invitado;
    const hasPhoto = Number(invitado.fotoStorageId) > 0;
    const eyeTooltipId = `invitado-ver-persona-${invitado.idInvitado}`;
    const cartTooltipId = `invitado-carrito-${invitado.idInvitado}`;
    const accessTooltipId = `invitado-acceso-${invitado.idInvitado}`;

    return (
      <Container>
        <div className={s.info}>
          {/* Fotografía de la persona */}
          <div
            className={`${s.foto} ${
              hasPhoto ? s.fotoConImagen : s.fotoSinImagen
            }`}
          >
            {hasPhoto ? (
              <img
                src={`${BFF_URL}${IMAGES_ENDPOINT}/${invitado.fotoStorageId}`}
                alt={`Fotografía de ${invitado.nombreCompleto || "persona"}`}
              />
            ) : (
              <FontAwesomeIcon icon={faUser} />
            )}
          </div>

          {/* Header con datos a la derecha de la foto */}
          <div
            className={`${s.persona} ${
              hasPhoto ? s.personaConImagen : s.personaSinImagen
            }`}
          >
            <div className={s.heading}>
              {/* Nombre completo (grande) */}
              <h3>{invitado.nombreCompleto}</h3>

              {/* Acciones (íconos) a la derecha del nombre */}
              <div className={s.actions}>
                <>
                  <span className={s.actionLink} id={accessTooltipId}>
                    <FontAwesomeIcon
                      icon={faInfoCircle}
                      color={invitado.tieneAcceso ? "#008080" : "#600"}
                    />
                  </span>
                  <UncontrolledTooltip
                    placement="bottom"
                    target={accessTooltipId}
                  >
                    {invitado.tieneAcceso
                      ? "El invitado tiene acceso"
                      : (invitado.razonesSinAcceso || []).length
                      ? invitado.razonesSinAcceso.map((razon, index) => (
                          <div key={index}>{razon}</div>
                        ))
                      : "No cuenta con acceso al club"}
                  </UncontrolledTooltip>
                </>

                <>
                  <a
                    className={s.actionLink}
                    href={`/invitado/${invitado.idPersona}/detalle`}
                    target="_blank"
                    id={eyeTooltipId}
                  >
                    <FontAwesomeIcon icon={faEye} />
                  </a>
                  <UncontrolledTooltip placement="bottom" target={eyeTooltipId}>
                    Ver persona
                  </UncontrolledTooltip>
                </>

                {userHasPermission(MENU_CARRITO) && (
                  <>
                    <a
                      className={s.actionLink}
                      href={`/productos/carrito/${invitado.idPersona}`}
                      target="_blank"
                      id={cartTooltipId}
                    >
                      <FontAwesomeIcon icon={faShoppingCart} />
                    </a>
                    <UncontrolledTooltip
                      placement="bottom"
                      target={cartTooltipId}
                    >
                      Ver carrito
                    </UncontrolledTooltip>
                  </>
                )}
              </div>
            </div>

            {/* División de nombre y parte inferior */}
            <hr />

            {/* Identificador de la persona, al lado de la foto */}
            <p>ID Persona: {invitado.idPersona}</p>
          </div>
        </div>

        {/* Cards informativos */}
        <InvitadosDetalleInfo detalle={invitado} />

        {/* Tabs */}
        <InvitadosDetalleTab {...this.props} detalle={invitado} />
      </Container>
    );
  }
}
